if (!customElements.get('variant-label')) {
  class VariantLabel extends HTMLElement {
    constructor() {
      super();
      this.variantLabels = this.querySelectorAll('.js-variant-label');
      window.initLazyScript(this, this.initLazySection.bind(this));
    }

    initLazySection() {
      if (this.variantLabels) {
        // Bind to on:variant:change event for this product
        const variantPicker = this.closest('.product').querySelector('variant-picker');
        if (variantPicker) {
          variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
        }
        if (this.dataset.currentVariantId) {
          this.setVisibleVariantLabel(this.dataset.currentVariantId);
        }
      }
    }

    /**
     * Sets the visible variant variantLabels.
     * @param {string} variantId - The variant id
     */
    setVisibleVariantLabel(variantId) {
      console.log("my check is running");
      this.variantLabels.forEach((variantLabel) => {
        console.log("current id "+variantLabel.dataset.variantId+" || stock_status "+variantLabel.dataset.isInStock);
        variantLabel.hidden = variantLabel.dataset.variantId.toString() !== variantId.toString();
        if(variantLabel.dataset.variantId.toString() === variantId.toString()){
          console.log("actual condition met")
          console.log(typeof variantLabel.dataset.isInStock);
          const actual_add_to_cart = document.querySelector('.actual-add-to-cart');
          const actual_buy_it_now  = document.querySelector('.shopify-payment-button');
          if(actual_add_to_cart && variantLabel.dataset.isInStock == 'true'){
            console.log("element found instock true")
            actual_add_to_cart.innerHTML = window.theme.strings.addToCart;
            actual_add_to_cart.removeAttribute('disabled');
            if(actual_buy_it_now){
              actual_buy_it_now.style.display = 'block';
            }
          }
          else if(actual_add_to_cart && variantLabel.dataset.isInStock == 'false'){
            console.log("element found instock false")
            actual_add_to_cart.innerHTML = window.theme.strings.outOfStock;
            actual_add_to_cart.setAttribute('disabled', 'disabled');
            if(actual_buy_it_now){
              actual_buy_it_now.style.display = 'none';
            }
          }
        }
      });
    }

    /**
     * Handles a 'change' event on the variant picker element
     * @param {object} evt - Event object
     */
    handleVariantChange(evt) {
      if (evt.detail.variant) {
        this.setVisibleVariantLabel(evt.detail.variant.id);
      }
    }
  }

  customElements.define('variant-label', VariantLabel);
}
